import React, { ReactNode } from 'react'
import { isBrowser } from '../../../react-utils'
import withAnalytics from '../../../utils/withAnalytics'
import './open-in-codespaces.css'
import style from './open-in-codespaces.module.css'

interface OpenInGitHubCodeSpacesProps {
  href: URL
  text: string
  headerText: string
  styleclass?:
    | 'small-open-in-codespaces'
    | 'medium-open-in-codespaces'
    | 'large-open-in-codespaces'
}

export const OpenInGitHubCodeSpaces: React.FC<OpenInGitHubCodeSpacesProps> = ({
  href,
  text,
  headerText,
  styleclass,
}) => {
  const fptiData = typeof window !== `undefined` && window.fpti

  const handleOpenInCodeSpaces = () => {
    if (fptiData) {
      const event = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: 'openincodespaces',
          component: 'devdiscoverynodeweb',
          space_key: 'SKEXJE',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(event)
      }
    }
    isBrowser && window.open(href, '_blank')
  }

  return (
    <>
      {headerText && (
        <p className={style.open_in_codespace__header}>{headerText}</p>
      )}
      {text && (
        <p className={style.open_in_codespace__text}>
          <span dangerouslySetInnerHTML={{ __html: text }} />
        </p>
      )}
      <button
        className={styleclass}
        onClick={() => handleOpenInCodeSpaces()}
        // eslint-disable-next-line react/no-unknown-property
        alt-text="Open In GitHub Codespaces"
      />
    </>
  )
}

export default withAnalytics(OpenInGitHubCodeSpaces)
